import React from 'react';
import Popup from '../Popups/Popup';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import AssessmentAptitudeResults from '../AssessmentAptitudeResults/AssessmentAptitudeResults';
import AssessmentBehaviorResults from '../AssessmentBehaviorResults/AssessmentBehaviorResults';
import AssessmentConfidenceResults from '../AssessmentConfidenceResults/AssessmentConfidenceResults';

export default class AssessmentResultsPopup extends React.Component {
	constructor(props) {
		super(props);

		this.pageRef = React.createRef();
		this.onPrint = this.onPrint.bind(this);
	}

	render() {
		const { isVisible, onHide, assessment, personalData = {} } = this.props;

		return (
			<PopupWithUseClickOutside
				isPopupVisible={isVisible}
				onHidePopup={onHide}
				style={{ maxWidth: '750px' }}
			>
				<Popup
					title={
						<h1 className="card-title">
							{I18n.t('admin.user_profile.assessment_results')}
						</h1>
					}
					onHidePopup={onHide}
				>
					<div style={{ position: 'relative' }}>
						<a
							onClick={this.onPrint}
							className="btn btn-secondary btn-sm"
							style={{ position: 'absolute', top: '80', right: '0' }}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="currentColor"
								className="bi bi-printer-fill"
								viewBox="0 0 16 16"
							>
								<path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1" />
								<path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
							</svg>
						</a>
						<div ref={this.pageRef}>
							{this.renderPersonalData(personalData)}
							{this.renderCompletedAt()}
							<div
								style={{
									height: $(window).innerHeight() - 165,
									overflow: 'scroll'
								}}
							>
								{/* Assessment Aptitude Results */}
								{this.renderTitle('Aptitude')}
								<AssessmentAptitudeResults results={assessment.data.results} />

								{/* Assessment Behavior Results*/}
								{this.renderTitle('Behavior')}
								<AssessmentBehaviorResults
									questions={assessment.data.sections[1].elements}
									entries={assessment.data.entries}
								/>

								{/* Assessment Confidence Results */}
								{this.renderTitle('Confidence')}
								<AssessmentConfidenceResults
									questions={assessment.data.sections[0].elements}
									entries={assessment.data.entries}
								/>
							</div>
						</div>
					</div>
				</Popup>
			</PopupWithUseClickOutside>
		);
	}

	renderTitle(title) {
		return (
			<div
				style={{
					width: '100%',
					backgroundColor: '#252B3B',
					color: 'white',
					padding: '10px',
					marginTop: '10px'
				}}
			>
				{title}
			</div>
		);
	}

	renderPersonalData(personalData) {
		const { fields = [] } = personalData;
		const first_name = fields.find((field) => field.name === 'firstName');
		const last_name = fields.find((field) => field.name === 'lastName');
		const email_address = fields.find((field) => field.name === 'emailAddress');

		if (
			first_name &&
			first_name.value &&
			last_name &&
			last_name.value &&
			email_address &&
			email_address.value
		) {
			return (
				<h6 style={{ padding: '0 0 10px 0' }}>
					{first_name.value.asString} {last_name.value.asString} ({email_address.value.asString})
				</h6>
			);
		} else {
			return null;
		}
	}
	renderCompletedAt() {
		const { testCompletedAt } = this.props;
		const date = new Date(testCompletedAt);
		if (date instanceof Date && !isNaN(date)) {
			return (
				<h6 style={{ marginBottom: '1rem' }}>
					{I18n.t('submitted_on', {
						date: date.toLocaleDateString('en-us', {
							weekday: 'long',
							year: 'numeric',
							month: 'short',
							day: 'numeric'
						}),
						time: date.toLocaleTimeString('en-us', {
							hour: 'numeric',
							minute: 'numeric'
						})
					})}
				</h6>
			);
		}
	}

	onPrint() {
		if (this.pageRef.current) {
			const hideFrame = document.createElement('iframe');
			hideFrame.onload = () => {
				const closePrint = () => {
					document.body.removeChild(hideFrame);
				};
				hideFrame.contentWindow.onbeforeunload = closePrint;
				hideFrame.contentWindow.onafterprint = closePrint;
				hideFrame.contentWindow.print();
			};
			hideFrame.style.display = 'none';
			document.body.appendChild(hideFrame);

			// Copy the content to the iframe
			const content = this.pageRef.current.innerHTML;
			hideFrame.contentDocument.body.innerHTML = content;
		}
	}
}
